import { jsx as n, jsxs as s } from "@emotion/react/jsx-runtime";
import { useRef as k } from "react";
import { useKeyboardEvents as M } from "@partoohub/hooks";
import { useMenuHover as h } from "../../../../hooks/useHover.js";
import { StyledLink as u, BaseMenuItemContainer as I, BaseMenuContentContainer as L, SidebarIconContainer as v } from "./BaseMenu.styled.js";
import { BaseMenuIcon as y } from "./BaseMenuIcon.js";
import { StyledStatus as C } from "../MenuItem/MenuItem.styled.js";
const j = ({
  route: e,
  children: i,
  callback: r,
  isActive: a = !1,
  hasNotification: d = !1
}) => {
  const t = k(null), l = e.type === "externalUrl" || e.type === "partnerLink";
  M({
    ref: t,
    onEnter: () => r?.()
  });
  const {
    isHovered: c,
    handleMouseEnter: m,
    handleMouseLeave: p
  } = h(), f = e.type === "partnerLink", o = /* @__PURE__ */ s(L, { children: [
    /* @__PURE__ */ s(v, { children: [
      d && /* @__PURE__ */ n(C, { variant: "danger" }),
      /* @__PURE__ */ n(y, { isHovered: c, route: e, isActive: a })
    ] }),
    i
  ] });
  return l ? /* @__PURE__ */ n(u, { "data-track": `nav-link__${e.dataTrackId.toLowerCase()}__partner-link`, href: e.href, variant: e.color ?? "secondary", target: "_blank", hideExternalIcon: f, children: o }) : /* @__PURE__ */ n(I, { ref: t, onMouseEnter: m, onMouseLeave: p, onClick: r, "data-track": e.dataTrackId, "data-partoorobot": e.dataPartooRobot, isActive: a, tabIndex: 0, children: o });
};
export {
  j as BaseMenuItem
};
